import $ from 'jquery';

function init({ selector = '.js-newsletter-form'} = {}) {
    if (!selector){
        return;
    }

    // Scroll to newsletter module when submission is true
    if (location.search === '?newsletter=true') {
        $('html, body').animate({
            scrollTop: $('.js-newsletter-module').offset().top
        }, 1000, function() {
            // Clean url so the user is shown the form on page refresh
            const cleanUrl = window.location.href.split('?')[0];
            history.replaceState({}, document.title, cleanUrl);
        });
    }

    // Declare necessary variables
    const errorMessages = $('.js-error-message');
    const hiddenFields = $(selector).find('input[type="hidden"]');
    const loader = $('.js-loader');
    const formFields = {
        name: {
            selector: $(selector).find('#newsletterName'),
            isValid: false
        },
        email: {
            selector: $(selector).find('#newsletterEmail'),
            isValid: false
        },
        terms: {
            selector: $(selector).find('#newsletterTerms'),
            isValid: false
        }
    };

    // Validate email through regex
    function validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        return emailRegex.test(email);
    }

    // Validate form fields
    function validateFormFields() {
        // Name
        if (formFields.name.selector.val() !== '') {
            formFields.name.isValid = true;
        }

        // Email
        if (formFields.email.selector.val() !== '') {
            formFields.email.isValid = validateEmail(formFields.email.selector.val());
        }

        // Terms
        if (formFields.terms.selector.is(':checked')) {
            formFields.terms.isValid = true;
        }

        return formFields.name.isValid && formFields.email.isValid && formFields.terms.isValid;
    }

    // Toggle error messages and classes
    function toggleErrors() {
        for (const fieldName in formFields) {
            const field = formFields[fieldName];

            if (!field.isValid) {
                field.selector.addClass('has-error');
                field.selector.parent().find('.js-error-message').show();
            } else {
                field.selector.removeClass('has-error');
                field.selector.parent().find('.js-error-message').hide();
            }
        }
    }

    function showInlineSuccessMessage() {
        const container = $('.js-newsletter-container');
        const url = window.location.href + '?newsletter=true';

        // Call same page with success query string to get the success message's html
        $.ajax({
            url,
            method: 'GET',
            success: function(e) {
                const successMessage = $(e).find('.js-success-message');

                container.html(successMessage);
                loader.hide();
            }
        });
    }

    // Submit form
    $(selector).submit(function(e){
        e.preventDefault();
        const url = $(selector).attr('action');
        const isPopup = $(selector).attr('data-popup') === 'true';
        const isValid = validateFormFields();

        errorMessages.hide();

        if (isValid) {
            const data = {
                firstname: formFields.name.selector.val(),
                email: formFields.email.selector.val()
            };

            // Append hidden fields to data
            if (hiddenFields) {
                hiddenFields.each(function() {
                    const fieldName = $(this).attr('name');
                    const fieldValue = $(this).val();

                    if (fieldName) {
                        data[fieldName] = fieldValue;
                    }
                });
            }

            $.ajax({
                url,
                method: 'POST',
                data,
                success: function() {
                    if (isPopup) {
                        loader.show();
                        showInlineSuccessMessage();
                    } else {
                        // Refresh page with query string to show success html
                        window.location.href = window.location.href + '?newsletter=true';
                    }
                },
                error: function() {
                    toggleErrors();
                }
            });
        } else {
            toggleErrors();
        }
    });
}

export default {
    init
};
